class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    setTimeout(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    // This line toggles a class on the drawer itself so you can hide/show elements via CSS
    this.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const element = document.querySelector(section.selector) || document.getElementById(section.id);
      if (element && parsedState.sections[section.id]) {
        const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
        const liveSection = html.querySelector(section.selector || '.shopify-section');
        
        if (liveSection) {
          element.innerHTML = liveSection.innerHTML;
        }
      }
    });

    // Re-bind overlay click
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }
}
customElements.define('cart-drawer', CartDrawer);

/* --- QUANTITY & REMOVE LOGIC --- */
class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onQtyChange.bind(this));
  }

  onQtyChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: ['cart-drawer', 'cart-icon-bubble']
    });

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body
    })
    .then((response) => response.json())
    .then((state) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.renderContents(state);
    });
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

/* --- THE REMOVE FIX --- */
document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('cart-remove-button button');
  if (!removeButton) return;

  event.preventDefault();
  event.stopImmediatePropagation(); // Kills the double-removal bug

  const itemId = removeButton.getAttribute('data-cart-item-key');
  
  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: itemId, 
      quantity: 0,
      sections: ['cart-drawer', 'cart-icon-bubble']
    })
  })
  .then(res => res.json())
  .then(state => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.renderContents(state);
  });
}, true);